export default "__VITE_ASSET__CAO_gLvd__";